import { render, staticRenderFns } from "./payments-list.vue?vue&type=template&id=5f35d196&"
import script from "./payments-list.vue?vue&type=script&lang=js&"
export * from "./payments-list.vue?vue&type=script&lang=js&"
import style0 from "./payments-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports